module.exports = __webpack_public_path__ + "static/media/yourdata_04.7b28d37b.jpg";